//CC-Common imports
import { AuthConstants } from '@therealmanage/ciranet-ui-common';

export class Constants {
  static localeEnglishUS = 'en-US';
  static ciraConnectCompanyName = 'CiraConnect';
  static passwordSpecialCharactersAllowable =
    AuthConstants.passwordSpecialCharactersAllowed.join('');
  static noPropertiesFound =
    'No properties found.\nAdd your property to continue';

  static smallDeviceMaxWidth = 768;
  static extraSmallDeviceMaxWidth = 575;
  static defaultCiraChatDepartment = 'RM Owner-Resident Portal';
  static defaultManagementCompanyName = 'Management Company';

  static portalTypeCode = 'RP';
  static tokenIssuer = 'CiraConnect_RP';

  static splitterLeftPanelWidth = '30';
  static splitterRightPanelWidth = '70';

  static helpSidebarPrimaryWidth = '25';
  static helpSidebarSecondaryWidth = '75';

  static minDate = new Date(1900, 0, 1);
  static maxDate = new Date(2100, 0, 1);

  static defaultAccAcknowledgementText = `Complete the forms and attach any supporting documentation, plans and/or photos of the
                        improvement. Your information will be reviewed in accordance with the guidelines for your
                        community. Work should not commence until the committee has provided feedback.`;

  static privacyPolicyUrl = '/privacy-policy';
  static aboutCiraNetUrl = '/about-ciranet';
  static termsAndConditionsUrl = '/terms-and-conditions';
  static realManageUrl = 'https://www.realmanage.com';
}
